import apiClient from './client';

export const reportsApi = {
  getAll: (params) => apiClient.get('/api/reports', { params }),

  getSummary: (params) => apiClient.get('/api/reports/summary', { params }),

  getBlocked: (params) => apiClient.get('/api/reports/blocked', { params }),

  getMessages: (params) => apiClient.get('/api/reports/messages', { params }),

  getMessageDashboard: (params) => apiClient.get('/reports/message-dashboard', { params }),

  getBroadcasts: (params) => apiClient.get('/api/reports/broadcasts', { params }),

  getCustomers: (params) => apiClient.get('/api/reports/customers', { params }),

  getConversations: (params) => apiClient.get('/api/reports/conversations', { params }),

  getBots: (params) => apiClient.get('/api/reports/bots', { params }),

  getOperators: (params) => apiClient.get('/api/reports/operators', { params }),

  getTemplates: (params) => apiClient.get('/api/reports/templates', { params }),

  getDetails: (id) => apiClient.get(`/api/reports/${id}/details`),

  export: (type, params) => apiClient.get(`/api/reports/export/${type}`, {
    params,
    responseType: 'blob'
  }),

  getDashboard: (params) => apiClient.get('/api/reports/dashboard', { params }),

  getDashboardStats: () => apiClient.get('/api/reports/dashboard-stats'),

  getChartData: (type, params) => apiClient.get(`/api/reports/chart/${type}`, { params }),

  getActivityLog: (params) => apiClient.get('/api/reports/activity', { params }),
};

export default reportsApi;
